import { config } from '../../config';
import { baseUrls } from '../../constants/urls';
import jwt from 'jwt-decode';

export const mfaURLs: string[] = [
  baseUrls.cashMovementNewRequest.replace(':paymentType', 'withdrawal'),
  baseUrls.cashMovementNewRequest.replace(':paymentType', 'ach-pull'),
  baseUrls.cashMovementBulkRequest,
  baseUrls.cashMovementNewRequestSubmitted.replace(':paymentType', 'withdrawal'),
  baseUrls.cashMovementNewRequestSubmitted.replace(':paymentType', 'ach-pull')
];

export const isMfaEnabled = config.enableMFA === 'true';

export const checkIsMfaRequired = (pathName: string): boolean => {
  const isMfaURL = mfaURLs.some((url) => pathName.includes(url));

  return isMfaEnabled && isMfaURL;
};

export const getMfaExpFromToken = (token: string): number | null => jwt<any>(token)[config.auth0.namespace + 'expMfaTimestamp'];

export const isMfaTokenValid = (token: string) => {
  const expMfaTimestamp = jwt<any>(token)?.[config.auth0.namespace + 'expMfaTimestamp'];

  const currentTime = new Date().getTime();
  return currentTime < expMfaTimestamp;
};

export const USE_MFA_FLAG = 'useMfa';
export function askUserToMfa() {
  window.location.href = `${window.location.origin}${window.location.pathname}?${USE_MFA_FLAG}=true`;
}
